import styled from '@emotion/styled';

import { buttonStyles } from '../../styles/buttons';
import Link from '../Link';

const Button = styled(Link, {
  shouldForwardProp: (prop) => !['light', 'size', 'theme'].includes(prop)
})`${buttonStyles}`;

export default Button;
